import { useMutation } from '@tanstack/react-query';

/** 履歴書から抽出した参照項目 */
export type ResumeField = {
  key: string;
  label: string;
  value: string;
};

/** アップロードAPIのレスポンス（表示用ファイル名 + 抽出した参照項目） */
export type PersonaUploadResult = {
  filename: string;
  fields: ResumeField[];
};

/**
 * 履歴書などのファイルをアップロードし、テキストから抽出した参照項目を取得するミューテーション。
 * 抽出した項目はカスタマイズのチェックボックスに提示し、選択した項目のみをペルソナ構築に使う。
 */
export default function useUploadPersonaFile() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async (file: File): Promise<PersonaUploadResult> => {
      const form = new FormData();
      form.append('file', file);

      const response = await fetch('/agent/api/ai_job_search_persona_uploads', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-CSRF-Token': token },
        body: form,
      });

      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        const message =
          typeof errorBody?.error === 'string'
            ? errorBody.error
            : 'ファイルのアップロードに失敗しました';
        throw new Error(message);
      }

      return response.json();
    },
  });
}
